import { useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { SelectedAddress } from '../redux/legacy/reducers/ducks/new/Address/Address.types';
import {
  setSelectedAddress as storeSelectedAddress,
  restoreSelectedAddress,
} from '../redux/legacy/reducers/ducks/new/Address/AddressReducer';
import { selectSelectedAddress } from '../redux/legacy/reducers/ducks/new/Address/AddressSelector';
import { readDeliveryAddress } from '../util/deliveryAddressStorage';

export function useWhere() {
  const dispatch = useDispatch();
  const store = useStore<any>();
  const storedAddress = useSelector(selectSelectedAddress);

  const setSelectedAddress = (address: SelectedAddress | null) =>
    dispatch(storeSelectedAddress(address));

  useEffect(() => {
    // Redux is authoritative once selected; a remount must not restore an old
    // account's legacy ID over a newly saved destination.
    const current = store.getState().address;
    if (current.selectionInitialized || current.selectedAddress) return;
    dispatch(restoreSelectedAddress(readDeliveryAddress()));
  }, []);

  return {
    dAddress: storedAddress,
    selectedAddress: storedAddress,
    setSelectedAddress,
  };
}

export default useWhere;
